export const BUTTON_CELL_SCHEVRON_OPTION_DISPLAY_NAME =
    "ButtonCellSchevronOption";
